<div class="modal-body">
    <h3 class="modal-title">Copy Line for Multiple Employees</h3>
    <h5>This will copy the selected line to one or more other employees.</h5>
</div>

<div class="modal-body" id="bulkEmployeeAdd">
    <div class="card panel-default">
        <div class="card-body">
            <form #groupClockForm="ngForm">
                <div class="row">
                    <div class="col-md-12" style="margin-bottom: 12px;">
                        <div style="max-height: 360px; overflow-y: auto;">
                            <div *ngFor="let rowProperty of rowProperties">
                                <label> {{sharedColumnInfo[rowProperty].ColumnLabel}} : </label> {{sharedColumnInfo[rowProperty].IsCombo ? row[rowProperty + "___@Value"] : row[rowProperty]}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" [hidden]="!payPeriod.EnableCrews" style="margin-bottom: 12px;">
                    <div class="col-md-6">
                        <label style="font-weight: 600; font-size: 1rem;">Add Crew</label>
                    <ng-select [(ngModel)]="selectedCrew"
                               name="selectedCrew"
                               (change)="crewChanged()"
                               [searchable]="true">
                        <ng-option *ngFor="let crew of crewsList" [value]="crew">{{crew.Crew}} - {{crew.CrewName}}</ng-option>
                    </ng-select>
                    </div>


                </div>
                <div class="row">
                    <div class="col-md-6">
                        <label style="font-weight: 600; font-size: 1rem;">Copy to Employee(s)</label>
                        <button class="float-right btn btn-sm" style="background-color: buttonface" (click)="selectNoneEmployees()">Select None</button>
                        <button class="float-right btn btn-sm" style="background-color: buttonface" (click)="selectAllEmployees()">Select All</button>
                        <ng-select [(ngModel)]="selectedEmployees"
                                   name="selectedEmployees"
                                   [items]="employees"
                                   bindLabel="EmployeeDisplayName"
                                   [multiple]="true"
                                   [searchable]="true"
                                   [closeOnSelect]="false">
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items | slice:0:50">
                                    <span class="ng-value-label">{{item.EmployeeDisplayName}}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">x</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 50">
                                    <span class="ng-value-label">{{items.length - 50}} more selected...</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col-md-6">
                        <div style="margin-bottom:12px;" [hidden]="!showCraftClassBox">
                            <input type="checkbox" class="largeCheckbox" [(ngModel)]="useEmplDefaultCraftClass" name="useEmplDefaultCraftClassCheckBox" /> Use employee's default Craft / Class
                        </div>
                        <div [hidden]="!showEarnCodeDefaultCheckbox" ng-style="showCraftClassBox && {'margin-top':'15px'} ||  {'margin-top':'48px'}">
                            <input type="checkbox" class="largeCheckbox" [(ngModel)]="useEmplDefaultEarnCode" name="useEmplDefaultEarnCodeCheckBox" /> Use employee's default Earncode
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default buttonNoLabel" (click)="cancelClicked()">Cancel</button>
    <button type="button" class="btn btn-success buttonNoLabel"
            [disabled]="selectedEmployees.length < 1 || addDisable"
            (click)="addClicked()">
        Add Line(s)
    </button>

</div>